
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-tours",
      function () {
        return require("private-next-pages/motorcycle-tours.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorcycle-tours"])
      });
    }
  